<template>
    <div class="sucai_dialog">
        <el-dialog
            :modal-append-to-body="false"
			title="素材库"
            class="sucai_dialog_pos"
			:visible.sync="visible"
			:width="dialogWidth"
            custom-class="sucai_dailog_wrap"
			@close="handleClose">
                <uploadList 
                    :uploadType="uploadType" 
                    :uploadTitle="uploadTitle" 
                    :btnTitle="btnTitle" 
                    :accept="accept" 
                    :limit="limit"
                    :multiple="multiple" 
                    :addNumber="addNumber" 
                    :listW="listW" 
                    :listH="listH"
                    :isAddSucaiFlag="isAddSucaiFlag"
                    :rowNum="rowNum" 
                    :isUploadFlag="isUploadFlag" 
                    :iscustomFlag="iscustomFlag"
                    :disabledFun="disabledFun"
                    @select="selectList"
                    @uploadLocal="uploadLocal"
                    ref="uploadList"
                ></uploadList>
                <uploadFile
                    v-show="false"
                    :uploadType="uploadType" 
                    :accept="accept" 
                    :multiple="multiple" 
                    :uploadSize="uploadSize" 
                    :autoUpload="autoUpload"
                    :isAddSucaiFlag="isAddSucaiFlag"
                    ref="uploadFile" 
                    :isCancelFlag="isCancelUploadFlag"
                    @change="uploads"
                    @beforeUpload="beforeUpload"
                    @uploadSucess="uploadSucess"
                ></uploadFile>
                <div slot="footer" class="dialog-footer">
					<el-button @click="cancel">取 消</el-button>
					<el-button type="primary" @click="sure" :disabled="!selectFile.length">确 定</el-button>
				</div>

        </el-dialog>
    </div>
</template>
<script>
import uploadList from '../uploadList/index.vue'
import uploadFile from '../newUpload/upload.vue'
export default {
    name:'SucaiDialog',
    model: {
        prop: 'visible',
        event: 'changeVisible'
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        multiple: {
            type:Boolean,
            default: false
        },
        uploadType: {
            type: String,
            default: 'video'
        },
        uploadTitle: {
            type: String,
            default: '点击上传本地视频'
        },
        btnTitle: {
            type:String,
            default: '播放'
        },
        accept: {
            type: Array,
            default: () => ['.mp4','.mov']
        },
        addNumber: {
            type: Number,
            default: 1
        },
        listW: {
            type: String,
            default: '240px'
        },
        listH: {
            type: String,
            default: '185px'
        },
        rowNum: {
            type: Number,
            default: 4
        },
        limit: {
            type: Number,
            default: 10
        },
        dialogWidth: {
            type: String,
            default: '870px'
        },
        isUploadFlag: {
            type: Boolean,
            default: true
        },
        uploadSize: {
            type: String,
            default: '300mb'
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        isCancelUploadFlag: {
            type: Boolean,
            default: true
        },
        iscustomFlag: {
            type: Boolean,
            default: false
        },
        isAddSucaiFlag: {
            type: Boolean,
            default: true
        },
        disabledFun: {
            type: Function,
            default: () => false
        }
        
    },
    provide() {
        return {
            parent: this
        }
    },
    data() {
        return {
            selectFile: [],
            diaLogFlag: false
        }
    },
    components: {
        uploadList,
        uploadFile
    },
    methods: {
        cancel() {
            this.$emit('changeVisible', false)
        },
        sure() {
            this.$emit('changeVisible', false)
            if(this.isCancelUploadFlag) {
                this.$refs.uploadFile.cancelUpload()
            }
            this.$emit('change', this.selectFile)
            this.$emit('sureClick', this.selectFile)
        },
        handleClose() {
            this.$emit('changeVisible', false)
        },
        sucaiDialogUpload() {
            this.$refs.uploadFile.uploadFile()
        },
        beforeUpload(list) {
            this.$emit('changeVisible', false)
            this.$emit('beforeUpload', list)
        },
        uploads(list) {
            this.$emit('change', list)
            this.$emit('changeProcess', list)
        },
        selectList(list) {
          this.selectFile = list
        },
        open() {
            this.$emit('changeVisible', true)
        },
        uploadSucess(list, item) {
            this.$emit('uploadSucess', list, item)
        },
        uploadLocal() {
            this.$emit('uploadLocal')
        },
        cancelUpload() {
           this.$refs.uploadFile.cancelUpload()
        }
    },
    watch: {
        visible(news) {
           if(news) {
               this.$nextTick(() => {
                   this.$refs.uploadList.getMaterialIndex()
               })
           }
        }
    }

}
</script>
<style lang="less">
    .sucai_dailog_wrap {
        margin-top: 8vh!important;
        .el-dialog__header {
            padding: 20px 20px 10px 20px;
            .el-dialog__title {
                font-size: 18px;
                font-weight: 600;
                color: #37383c;
            }
        }
        .el-dialog__body {
            padding: 0px 20px 15px 20px;
            .pagination_wrap {
                padding: 0;
                align-items: flex-start;
                >span {
                    height: 28px;
                    line-height: 28px;
                }
            }
        }
    }
    // .sucai_dialog_pos {
    //     z-index: 1999!important;
    // }
</style>
